let slideIndex = 0;

// Check if the content overflows the slider and adjust styles accordingly
function checkOverflow() {
  const slider = document.getElementById('otherScentsProductSlider');
  const content = document.getElementById('center-content');
  const arrows = document.querySelector('.change-slide-arrows-container');

  // Calculate total width of content
  const totalContentWidth = Array.from(content.children).reduce((total, child) => {
    return total + child.offsetWidth +
      parseFloat(getComputedStyle(child).marginLeft) +
      parseFloat(getComputedStyle(child).marginRight);
  }, 0);

  content.style.maxWidth = `${totalContentWidth}px`;

  // Toggle visibility of arrows and adjust content alignment based on overflow
  if (totalContentWidth > slider.clientWidth) {
    content.classList.remove('justify-center');
    slider.classList.remove('flex', 'justify-center');
    arrows.classList.remove('hidden');
  } else {
    content.classList.add('justify-center');
    slider.classList.add('flex', 'justify-center');
    arrows.classList.add('hidden');
  }
}

// Update the slide counter display
function updateSlideCounter(totalSlidesToShow) {
  document.getElementById('total-slides').innerText = totalSlidesToShow;
}

// Move the slider in the specified direction (left or right)
function moveSlide1(direction) {
  const slider = document.getElementById('otherScentsProductSlider').querySelector('.flex');
  const slides = slider.getElementsByClassName('product-card');
  
  // Calculate slide width and number of visible slides
  const slideWidth = slides[0].offsetWidth +
    parseFloat(getComputedStyle(slides[0]).marginLeft) +
    parseFloat(getComputedStyle(slides[0]).marginRight);
  const totalSlides = slides.length;
  const visibleSlides = Math.floor(slider.offsetWidth / slideWidth);
  const totalSlidesToShow = totalSlides - visibleSlides + 1;

  slideIndex += direction;

  // Ensure slideIndex is within bounds
  if (slideIndex < 0) {
    slideIndex = 0;
  } else if (slideIndex >= totalSlidesToShow) {
    slideIndex = totalSlidesToShow - 1;
  }

  // Center the current slide based on screen size
  const totalVisibleWidth = visibleSlides * slideWidth;
  const centerOffset = (slider.offsetWidth - totalVisibleWidth) / 2;
  const offset = slideIndex * slideWidth - centerOffset;

  // Update current slide display
  document.getElementById('current-slide').innerText = slideIndex + 1;
  updateSlideCounter(totalSlidesToShow);
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
  const storeEndpoint = `${window.location.protocol}//${window.location.host}`;
  const productHandle = '{{ product.handle }}';
  const endpoint = `${storeEndpoint}/products/${productHandle}`;

  moveSlide1(0);
  checkOverflow();

  // Handle radio button changes for scent selection
  document.querySelectorAll('.explore-scents-label input[type="radio"]').forEach(function (radio) {
    const labelSpan = radio.closest('label').querySelector('.explore-scents-btn');
    
    // Set initial styles based on checked state
    if (radio.checked) {
      labelSpan.classList.add('bg-grey-1000', 'text-white');
      labelSpan.classList.remove('bg-grey-30');
      updateProductCarousel(radio.id);
    }

    radio.addEventListener('change', function () {
      document.querySelectorAll('.explore-scents-label input[type="radio"]').forEach(function (otherRadio) {
        const otherLabelSpan = otherRadio.closest('label').querySelector('.explore-scents-btn');
        if (otherRadio !== radio) {
          otherLabelSpan.classList.remove('bg-grey-1000', 'text-white');
          otherLabelSpan.classList.add('bg-grey-30');
        }
      });
      if (radio.checked) {
        labelSpan.classList.add('bg-grey-1000', 'text-white');
        labelSpan.classList.remove('bg-grey-30');
        updateProductCarousel(radio.id);
      }
    });
  });

  // Function to update the product carousel based on selected scent
  function updateProductCarousel(filterId) {
    fetchProductCardData(filterId);
  }

  // Fetch product card data from the server
  async function fetchProductCardData(filterId) {
    try {
      // Utility function to toggle visibility of sections
      function toggleSections(visibleSection) {
        const sections = {
          'layers-well-with': document.getElementById('layers-well-with-section'),
          'recently-viewed': document.getElementById('recently-viewed-section'),
          'you-may-also-like': document.getElementById('you-may-also-like-section'),
        };

        Object.keys(sections).forEach((key) => {
          const section = sections[key];
          if (key === visibleSection) {
            setTimeout(() => fadeIn(section), 600);
          } else {
            fadeOut(section, () => {
              section.style.display = 'none'; // Hide section after fading out
            });
          }
        });
      }

      // Fade out animation
      function fadeOut(element, callback) {
        element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        element.style.opacity = '1';
        element.style.transform = 'translateX(0)';
        requestAnimationFrame(() => {
          element.style.opacity = '0';
          element.style.transform = 'translateX(24px)';
        });
        setTimeout(() => callback(), 600);
      }

      // Fade in animation
      function fadeIn(element) {
        element.style.display = 'block'; // Ensure the section is displayed
        element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        element.style.opacity = '0';
        element.style.transform = 'translateX(-24px)';
        requestAnimationFrame(() => {
          element.style.opacity = '1';
          element.style.transform = 'translateX(0)';
        });
        setTimeout(() => resetStyles(element), 600);
      }

      // Reset styles to their defaults
      function resetStyles(element) {
        element.style.transition = '';
        element.style.opacity = '';
        element.style.transform = '';
      }

      // Toggle sections based on selected scent
      switch (filterId) {
        case 'layers-well-with':
          toggleSections('layers-well-with');
          const response = await fetch(endpoint);
          if (!response.ok) throw new Error('Network response was not ok');
          const data = await response.text();
          const container = document.getElementById('layers-well-with-section');
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');
          const grid = doc.querySelector('.otherScentsProductSlider');
          
          // Clear and append new product cards
          container.innerHTML = '';
          const fragment = document.createDocumentFragment();
          grid.childNodes.forEach((element) => {
            if (element.nodeType === 1) {
              fragment.appendChild(element);
            }
          });
          container.appendChild(fragment);

          // Reinitialize the carousel and check overflow
          slideIndex = 0;
          moveSlide1(0);
          checkOverflow();
          document.dispatchEvent(new CustomEvent('reUpdateImageSrc'));
          break;

        case 'recently-viewed':
          toggleSections('recently-viewed');
          break;

        case 'you-may-also-like':
          toggleSections('you-may-also-like');
          break;

        default:
          console.warn(`Unknown filterId: ${filterId}`);
      }
    } catch (error) {
      console.error('Error fetching product card data:', error);
    }
  }

  // Observe DOM changes for specific sections
  function observeDOMChanges() {
    const observer = new MutationObserver(checkForKlevuRecs);
    const config = { childList: true, subtree: true };
    const targetNode = document.body;

    observer.observe(targetNode, config);
  }

  // Check for presence of klevu-recs and toggle visibility of related sections
  function checkForKlevuRecs() {
    const sections = [
      { section: document.getElementById('recently-viewed-section'), id: 'recently-viewed-radio' },
      { section: document.getElementById('you-may-also-like-section'), id: 'you-may-also-like-radio' },
    ];

    sections.forEach(({ section, id }) => {
      const klevuRecs = section.querySelector('.klevu-recs .klevuWrap .kuRECSContainer .kuRECSWrap .kuRECSResults');
      if (!klevuRecs) {
        document.getElementById(id).classList.add('hidden');
      } else {
        document.getElementById(id).classList.remove('hidden');
      }
    });
  }

  // Start observing DOM changes
  observeDOMChanges();

  // Recheck on window resize
  window.addEventListener('resize', () => {
    moveSlide1(0);
    checkOverflow();
  });
});